var map = {
	"./bx_account.svg": 48159,
	"./bx_account_active.svg": 43976,
	"./bx_balance.svg": 42554,
	"./bx_balance_active.svg": 53463,
	"./bx_customer.svg": 79078,
	"./bx_customer_active.svg": 78507,
	"./bx_earn.svg": 23124,
	"./bx_earn_active.svg": 29729,
	"./bx_home.svg": 46159,
	"./bx_home_active.svg": 56152,
	"./bx_notification.svg": 39571,
	"./bx_notification_active.svg": 70836,
	"./bx_notifications.svg": 42970,
	"./bx_notifications_active.svg": 59063,
	"./bx_profile.svg": 16949,
	"./bx_profile_active.svg": 32862,
	"./bx_report.svg": 76304,
	"./bx_report_active.svg": 73957,
	"./bx_savings.svg": 28259,
	"./bx_savings_active.svg": 31940,
	"./bx_staff.svg": 84752,
	"./bx_staff_active.svg": 90085,
	"./bx_withdraw.svg": 3424,
	"./bx_withdraw_active.svg": 40021
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69151;